<template>
    <b-col cols="12" xl="5">
        <base-card class="medication-card">
            <div class="medication-color" v-html="medicationName" :title="medicationName" v-b-tooltip.hover:title="medicationName"></div>
            <div v-html="reminderTypeTitle" :title="reminderTypeTitle"></div>
            <div v-if="tabletsLeft !== null" class="mt-2">{{ `${$t('tabletsLeft')}: ${tabletsLeft}` }}</div>
            <div class="mt-2 notes" v-html="notes"></div>
            <div class="buttons-section">
                <base-button blue @click="$emit('onEdit', id)">{{ $t('edit') }}</base-button>
                <base-button red @click="showDeleteDialog = true">{{ $t('remove') }}</base-button>
                <base-button v-if="tabletsReminderSent" white @click="resetTablets">{{ $t('resetTabletsReminder') }}</base-button>
            </div>
        </base-card>
        <base-dialog v-model="showDeleteDialog" :okBtnText="$t('yes')" :cancelBtnText="$t('no')" :okFn="() => { deleteMedication() }" :cancelFn="() => { showDeleteDialog = false }" :content="$t('confirmRemoveMedicationReminder')"></base-dialog>
    </b-col>
</template>

<script>
import { INTERVAL_FREQUENCY_OPTION, SEVERAL_TIMES_DAY_FREQUENCY_OPTION, WEEK_DAYS_FREQUENCY_OPTION, CYCLIC_FREQUENCY_OPTION } from '@/constants/medicationReminder'
import { getWeekDaysNamesWithValue, getLocalHourFromDate } from '@/helpers/date.helpers'
import BaseDialog from '@/components/base/BaseDialog.vue'
import medicationReminderRepository from '@/repositories/MedicationReminderRepository'

export default {
    components: {
        BaseDialog
    },
    data () {
        return {
            showDeleteDialog: false
        }
    },
    props: {
        id: String,
        medicationName: String,
        reminderType: Object,
        tabletsLeft: [Number, String],
        tabletsReminderSent: Boolean,
        notes: String,
        interval: Object,
        cyclic: Object,
        severalTimesWeek: Object,
        severalTimesDay: Array
    },
    methods: {
        deleteMedication () {
            medicationReminderRepository.delete(this.id).then(response => {
                if (response.data) {
                    this.$emit('onDelete')
                } else {
                    this.$store.dispatch('showDangerAlert', this.$t('defaultErrorMessage'))
                }
            })
        },
        resetTablets () {
            medicationReminderRepository.put(this.id, { resetTabletsReminder: true }).then(response => {
                if (response.data) {
                    this.$store.dispatch('showSuccessAlert', this.$t('changesPerformedCorrectly'))
                    this.$emit('onRefreshMedications')
                } else {
                    this.$store.dispatch('showDangerAlert', this.$t('defaultErrorMessage'))
                }
            })
        }
    },
    computed: {
        reminderTypeTitle () {
            if (this.reminderType.id === INTERVAL_FREQUENCY_OPTION) {
                return this.intervalTitle
            } else if (this.reminderType.id === SEVERAL_TIMES_DAY_FREQUENCY_OPTION) {
                return this.severalTimesDayTitle
            } else if (this.reminderType.id === WEEK_DAYS_FREQUENCY_OPTION) {
                return this.severalTimesWeekTitle
            } else if (this.reminderType.id === CYCLIC_FREQUENCY_OPTION) {
                return this.cyclicTitle
            }
        },
        intervalTitle () {
            return this.$t('medicationReminderEachXTime', { time: this.interval.hours || this.interval.days, interval: this.interval.hours ? this.$t('hours') : this.$t('days') })
        },
        severalTimesDayTitle () {
            return `${this.severalTimesDay.length} ${this.$t('timesToDay')} - ${this.severalTimesDay.map(item => { return getLocalHourFromDate(item.startDate) }).join(', ')}`
        },
        severalTimesWeekTitle () {
            return `${getWeekDaysNamesWithValue().filter(item => this.severalTimesWeek.weekDaysValues.includes(item.value)).map(item => item.name).join(', ')} - ${getLocalHourFromDate(this.severalTimesWeek.startDate)}`
        },
        cyclicTitle () {
            return `${this.$t('reminderMedicationForm.frequency.cyclic')} (${this.cyclic.cycle.tablets} ${this.$t('reminderMedicationForm.intakes')}, ${this.cyclic.cycle.pauses} ${this.$t('reminderMedicationForm.pauses')}) - ${getLocalHourFromDate(this.cyclic.startDate)}`
        }
    }
}
</script>
    
<style lang="scss" scoped>
.medication-card{
    min-width: 290px;
    white-space: nowrap;
    > div{
        text-overflow: ellipsis;
        overflow: hidden;
    }
}
.medication-color{
    color: $blue;
}
.notes{
    white-space: initial;
    font-size: .8rem;
}
.buttons-section{
    white-space: initial;
    margin-top: 1rem;
    > button{
        margin-top: 1rem;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/views/clinicHistory/medicationReminder/MedicationReminderBlock.vue